const features = {
    astroDim: {
        shortName: "ast",

        submode: "ast.mo",
        switchOnFadeTime: "ast.fs",
        astroDimFadeTime: "ast.fd",
        switchOffFadeTime: "ast.fe",

        outputLevel: "ast.l",

        outputLevel1: "ast.l1",
        outputLevel2: "ast.l2",
        outputLevel3: "ast.l3",
        outputLevel4: "ast.l4",
        outputLevel5: "ast.l5",

        energySavings: "ast.sav",

        time: "ast.t",

        time2: "ast.t0",
        time3: "ast.t1",
        time4: "ast.t2",
        time5: "ast.t3",

        latitude: "ast.lt",
        longitude: "ast.lg",
        timezone: "ast.tz",
    },
    configurationLock: {
        shortName: "key",

        enable: "key.en",
        fullOrPartialProtection: "key.all",
        masterPassword: "key.mp",
        servicePassword: "key.sp",
        permissionService: "key.ps",
        permissionUser: "key.pu",
        keyEncrypted: "key.em",
    },
    constantLumenOutput: {
        shortName: "clm",

        enable: "clm.en",

        outputLevel: "clm.l",

        outputLevel1: "clm.l1",
        outputLevel2: "clm.l2",
        outputLevel3: "clm.l3",
        outputLevel4: "clm.l4",
        outputLevel5: "clm.l5",
        outputLevel6: "clm.l6",
        outputLevel7: "clm.l7",
        outputLevel8: "clm.l8",

        operatingTime: "clm.t",

        operatingTime1: "clm.t1",
        operatingTime2: "clm.t2",
        operatingTime3: "clm.t3",
        operatingTime4: "clm.t4",
        operatingTime5: "clm.t5",
        operatingTime6: "clm.t6",
        operatingTime7: "clm.t7",
        operatingTime8: "clm.t8",
    },
    daliDexalSettings: {
        shortName: "da",

        dimmingCurve: "da.dc",
        fadeTime: "da.ft",
        fadeRate: "da.fr",
        extendedFadeTime: "da.ef",
        minimum: "da.mi",
        maximum: "da.ma",
        powerOnLevel: "da.po",
        powerOnColout: "da.poc",
        systemFailureLevel: "da.sf",
        systemFailureColour: "da.sfc",
        powerOnDelay: "da.pod",
    },
    daliDT8TWSettings: {
        shortName: "d8",

        coldestColourTemperature: "d8.cc",
        warmestColourTemperature: "d8.wc",

        powerOnColourTemperature: "d8.poc",
        physicalColdestColourTemperature: "d8.pcc",
        physicalWarmestColourTemperature: "d8.pwc",
        systemFailureColourTemperature: "d8.sfc",
    },
    dexalPowerSupplyUnit: {
        shortName: "dx",

        enable: "dx.en",
        mainsOffMode: "dx.mo",
    },
    dimmingModes: {
        shortName: "dm",

        enable: "dm.en",
    },
    dimToDark: {
        shortName: "d2d",

        enable: "d2d.en",
    },
    dimToWarm: {
        shortName: "dw",

        level0: "dw.l0",
        level1: "dw.l1",
        level2: "dw.l2",
        level3: "dw.l3",
        colorTemperature0: "dw.c0",
        colorTemperature1: "dw.c1",
        colorTemperature2: "dw.c2",
        colorTemperature3: "dw.c3",
    },
    driverGuard: {
        shortName: "dg",

        enable: "dg.en",
        prestartDerating: "dg.pre",
        powertDerating: "dg.pd",
        deratingLevel: "dg.dl",
        temperature: "dg.t",
    },
    emergencyMode: {
        shortName: "em",

        enable: "em.en",
        level: "em.set",
        lockDali: "em.ld",
    },
    endOfLife: {
        shortName: "eol",

        enable: "eol.en",
        time: "eol.ti",
    },
    lampOperatingTime: {
        shortName: "ops",

        enable: "ops.en",
        time: "ops.ti",
    },
    luminaireInfo: {
        shortName: "inf",

        version: "inf.ver",
        oemGtin: "inf.oemg",
        oemId: "inf.oemid",
        content: "inf.con",

        expectedBallastLifeTime: "inf.ebl",
        internalDriverReferenceTemperature: "inf.idt",
        expectedLightSourceLifeTime: "inf.elt",
    },
    ledModule: {
        shortName: "led",

        mode: "led.mo",
        currentWarmWhite: "led.tw",
        warmWhiteLuminous: "led.wf",
        coldWhiteColor: "led.ct",
        currentColdWhite: "led.tc",
        warmWhiteColor: "led.wt",
        coldWhiteLuminous: "led.cf",
        id: "led.id",
        ambientTemperature: "led.ta",
        temperatureWarm: "led.tw",
        temperatureCold: "led.tc",
        coldX: "led.cx",
        coldY: "led.cy",
        warmX: "led.wx",
        warmY: "led.wy",
        serialModuleCount: "led.ser",
    },
    mainsDIM: {
        shortName: "md",

        startVoltage: "md.sv",
        startLevel: "md.sl",
        stopVoltage: "md.ev",
        stopLevel: "md.el",
    },
    multipleOutputCurrent: {
        shortName: "mcu",

        channel1: "mcu.0",
        channel2: "mcu.1",
    },
    operatingCurrent: {
        shortName: "cur",

        enable: "cur.en",
        // "current": "cur.set",
        current: "cur.0",
        current2: "cur.1",
        power: "cur.pw0",
        voltage: "cur.u0",
        power2: "cur.pw1",
        voltage2: "cur.u1",
        lowpower: "cur.lpw0",
        mindimming: "cur.mdl",
    },
    presenceDetection: {
        shortName: "pd",

        level: "pd.l",
        startFadeTime: "pd.sf",
        holdTime: "pd.h",
        endFadeTime: "pd.ef",
    },
    softSwitchOff: {
        shortName: "sso",

        enable: "sso.en",
        time: "sso.ti",
    },
    stepDim: {
        shortName: "sd",

        switchOnFadeTime: "sd.f0",
        nominalLevel: "sd.l0",
        stepDimLevel: "sd.l1",
        startfadeTime: "sd.f1",
        endfadeTime: "sd.f2",
        holdTime: "sd.h1",
    },
    thermalProtection: {
        shortName: "tp",

        enable: "tp.en",
        mode: "tp.mo",
        sensorType: "tp.se",
        deratingLevel: "tp.dl",
        startDeratingResistorBased: "tp.sr",
        endDeratingResistorBased: "tp.er",
        shutOffResistorBased: "tp.or",
        startDeratingTemperatureBased: "tp.st",
        endDeratingTemperatureBased: "tp.et",
        shutOffTemperatureBased: "tp.ot",
    },
    touchDIMAndSensor: {
        shortName: "td",

        mode: "td.mo",

        enableShortPush: "td.esp",
        enableLongPush: "td.elp",
        enableDoublePush: "td.edp",

        enableShortPush1: "td.es1",
        enableLongPush1: "td.el1",
        enableDoublePush1: "td.ed1",

        enableShortPush2: "td.es2",
        enableLongPush2: "td.el2",
        enableDoublePush2: "td.ed2",

        mainPowerOnLevel: "td.po",
        mainPowerOnLevel2: "td.po2",
        mainPowerOnColour: "td.poc",

        fadeUpTime: "td.fu",
        switchOnLevel: "td.so",
        switchOnLevel2: "td.so2",
        switchOnColour: "td.soc",
        presenceHoldTime: "td.on",

        enablePresenceDetection: "td.epd",
        fadeDownTime03: "td.fs",
        standbyHoldTime: "td.sb",
        enableLightSensor: "td.els",
        enableHolidayMode: "td.ehm",
        autoDisablePD: "td.eap",

        mainsFrequency: "td.mf",
    },
    corridor: {
        shortName: "td_c",

        fadeUpTime: "td.fu",
        operativeLevel: "td.l0",
        holdTime00: "td.h0",
        fadeDownTime: "td.fd",
        standbyLevel01: "td.l1",
        holdTime01: "td.h1",
        fadeDownTime12: "td.fs",
        standbyLevel02: "td.l2",
        holdTime02: "td.h2",
        startupBehaviour: "td.su",
    },
    tuningFactor: {
        shortName: "tf",

        enable: "tf.en",
        reference: "tf.ref",
        minimum: "tf.min",
        maximum: "tf.max",
        level: "tf.set",
    },
    DaliAddressing: {
        shortName: "dadr",
    },
    zeroToTen: {
        shortName: "ztt",

        minimumDimmingLevel: "ztt.mi",
        dim2off: "ztt.off",
        xVoltage: "ztt.v",
    },
    rgbw: {
        shortName: "rgbw",
        channel: "rgbw.chn",
    },
    channelControl: {
        shortName: "ctrl",
        channel: "ctrl.chn",
    },
    permanentShutdown: {
        shortName: "dgps",
        channel: "dgps.en",
    },
    dimming: {
        shortName: "ygdim",
        enableAnalogDimming: "ygdim.endim",
        dimmingCurve: "ygdim.dc",
        dimmingMin: "ygdim.dmin",
        longSoftStart: "ygdim.lss",
        dimToZero: "ygdim.d2z",
    },
    ast8: {
        initialColour: "ast8.ci",
        outputColor: "ast8.col",
        outputColour1: "ast8.col1",
        outputColour2: "ast8.col2",
        outputColour3: "ast8.col3",
        outputColour4: "ast8.col4",
        outputColour5: "ast8.col5",
    },
    sd8: {
        stepDimColor1: "sd8.col1",
        stepDimColor2: "sd8.col2",
        stepDimColor3: "sd8.col3",
    },
    pd8: {
        presenceDetectionColor: "pd8.col",
    },
    powerOnDelay: {
        shortName: "pod",
        enable: "pod.en",
        dimLevel: "pod.lvl",
        delay: "pod.t",
    },
    diagnostics: {
        shortName: "spd",
        enableSpd: "spd.en",
        enableVisual: "spd.wng",
    },
    repeater: {
        shortName: "rpt",
        modeDT8: "rpt.mo8",
        modeDALIData: "rpt.mod",
        modeInputDevice: "rpt.moi",
        physMinLevel: "rpt.pml",
        enableModeSettings: "rpt.mos",
        updateDirectionsTWlimits: "rpt.upd",
        modeDetection: "rpt.mob",
        manufactureReset: "rpt.rst",
    },
    pwmDimMode: {
        shortName: "dpwm",
        enable: "dpwm.en",
        type: "dpwm.type",
    },
    astroDimTW: {
        shortName: "asttw",

        outputLevel: "asttw.l", //fake
        outputLevel1: "asttw.l1",
        outputLevel2: "asttw.l2",
        outputLevel3: "asttw.l3",
        outputLevel4: "asttw.l4",
        outputLevel5: "asttw.l5",
        outputLevel6: "asttw.l6",
        outputLevel7: "asttw.l7",
        outputLevel8: "asttw.l8",
        outputLevel9: "asttw.l9",
        outputLevel10: "asttw.l10",
        time: "asttw.t", //fake
        time2: "asttw.t0",
        time3: "asttw.t1",
        time4: "asttw.t2",
        time5: "asttw.t3",
        time6: "asttw.t4",
        time7: "asttw.t5",
        time8: "asttw.t6",
        time9: "asttw.t7",
        time10: "asttw.t8",

        initialColour: "asttw.ci",
        outputColour: "asttw.col", //fake
        outputColour1: "asttw.col1",
        outputColour2: "asttw.col2",
        outputColour3: "asttw.col3",
        outputColour4: "asttw.col4",
        outputColour5: "asttw.col5",
        outputColour6: "asttw.col6",
        outputColour7: "asttw.col7",
        outputColour8: "asttw.col8",
        outputColour9: "asttw.col9",
        outputColour10: "asttw.col10",

        // old refs
        submode: "asttw.mo",
        switchOnFadeTime: "asttw.fs",
        astroDimFadeTime: "asttw.fd",
        switchOffFadeTime: "asttw.fe",
    },
    astroDim10: {
        shortName: "ast10",
        outputLevel: "ast10.l", //fake
        outputLevel1: "ast10.l1",
        outputLevel2: "ast10.l2",
        outputLevel3: "ast10.l3",
        outputLevel4: "ast10.l4",
        outputLevel5: "ast10.l5",
        outputLevel6: "ast10.l6",
        outputLevel7: "ast10.l7",
        outputLevel8: "ast10.l8",
        outputLevel9: "ast10.l9",
        outputLevel10: "ast10.l10",
        time: "ast10.t", //fake
        time2: "ast10.t0",
        time3: "ast10.t1",
        time4: "ast10.t2",
        time5: "ast10.t3",
        time6: "ast10.t4",
        time7: "ast10.t5",
        time8: "ast10.t6",
        time9: "ast10.t7",
        time10: "ast10.t8",

        submode: "ast10.mo",
        switchOnFadeTime: "ast10.fs",
        astroDimFadeTime: "ast10.fd",
        switchOffFadeTime: "ast10.fe",
    },
    astroDim5: {
        shortName: "ast5",
        outputLevel: "ast5.l", //fake
        outputLevel1: "ast5.l1",
        outputLevel2: "ast5.l2",
        outputLevel3: "ast5.l3",
        outputLevel4: "ast5.l4",
        outputLevel5: "ast5.l5",
        outputLevel6: "ast5.l6",
        outputLevel7: "ast5.l7",
        outputLevel8: "ast5.l8",
        outputLevel9: "ast5.l9",
        outputLevel10: "ast5.l10",
        time: "ast5.t", //fake
        time2: "ast5.t0",
        time3: "ast5.t1",
        time4: "ast5.t2",
        time5: "ast5.t3",
        time6: "ast5.t4",
        time7: "ast5.t5",
        time8: "ast5.t6",
        time9: "ast5.t7",
        time10: "ast5.t8",

        submode: "ast5.mo",
        switchOnFadeTime: "ast5.fs",
        astroDimFadeTime: "ast5.fd",
        switchOffFadeTime: "ast5.fe",
    },
    adjustableDim: {
        shortName: "ajdim",
        outputResponseSelection: "ajdim.outres",
        enableAirborne: "ajdim.airen",
        outputSettingsWhenAirborne: "ajdim.airout",
        xPointVoltageValue: "ajdim.xv",
        yPointVoltageValue: "ajdim.yv",
        minimumOutputCurrentPercentage: "ajdim.xcur",
        triggerDimOnVoltagePoint: "ajdim.tron",
        triggerDimOffVoltagePoint: "ajdim.troff",
        airborneVoltage: "ajdim.trair",
        presetCurvesPos: "ajdim.pcnt",
        presetCurvesNeg: "ajdim.pcntn",
        curveSelection: "ajdim.curve",
    },
    pwmDim: {
        shortName: "pwmdim",
        dimmingLogic: "pwmdim.logic",
    },
    digitalDim: {
        shortName: "digdim",
        powerOnLevel: "digdim.powon",
        lossDimDataTime: "digdim.losstime",
        lossDimDataLevel: "digdim.losslvl",
    },
    dimSettings: {
        shortName: "dimset",
        minDimming: "dimset.mindim",
    },
    dipswitchcurrentsettings: {
        shortName: "dscs",
        cur0: "dscs.cur0",
        cur1: "dscs.cur1",
        cur2: "dscs.cur2",
        cur3: "dscs.cur3",
        cur4: "dscs.cur4",
        cur5: "dscs.cur5",
        cur6: "dscs.cur6",
        cur7: "dscs.cur7",
    },
    lightSensor: {
        shortName: "lsc",
        enable: "lsc.en",
        onVoltage: "lsc.onv",
        offVoltage: "lsc.offv",
        onLevel: "lsc.onl",
        offLevel: "lsc.offl",
        detectionTime: "lsc.dt",
    },
    pullUpCurrent: {
        shortName: "puc",
        pullUpCurrent: "puc.puc",
    },
    softStart: {
        shortName: "sst",
        enabled: "sst.en",
        allowed: "sst.al",
        time: "sst.t",
    },
    antiFlicker: {
        shortName: "afl",
        enable: "afl.en"
    },
    multiLumSettings: {
        shortName: "mls",

        numberOfPresets: "mls.cnum",

        presetCurrent1: "mls.c1",
        presetCurrent2: "mls.c2",
        presetCurrent3: "mls.c3",
        presetCurrent4: "mls.c4",
        presetCurrent5: "mls.c5",
        presetCurrent6: "mls.c6",
        presetCurrent7: "mls.c7",
        presetCurrent8: "mls.c8",

        activePresetIndex: "mls.cidx",

        onOffTime: "mls.oot",
        onOffCycles: "mls.cyc",
        holdUpTime: "mls.hut",
    },
    sensorMode: {
        shortName: "sens",
        silentDimmingLevel: "sens.sl",
        occupyDimmingLevel: "sens.ol",
        triggerVoltage: "sens.tv",
        detectionLogic: "sens.dl",
        fadingInTime: "sens.fi",
        holdUpTime: "sens.hu",
        fadingOutTime: "sens.fo",
    },
    astroDimSensor: {
        shortName: "astdimsens",
        silentDimmingLevel: "astdimsens.sl",
        occupyDimmingLevel: "astdimsens.ol",
        triggerVoltage: "astdimsens.tv",
        detectionLogic: "astdimsens.dl",
        fadingInTime: "astdimsens.fi",
        holdUpTime: "astdimsens.hu",
        fadingOutTime: "astdimsens.fo",
        occupyLevel: "astdimsens.oa", //fake
        occupyLevel1: "astdimsens.oa1",
        occupyLevel2: "astdimsens.oa2",
        occupyLevel3: "astdimsens.oa3",
        occupyLevel4: "astdimsens.oa4",
        occupyLevel5: "astdimsens.oa5",
        occupyLevel6: "astdimsens.oa6",
        occupyLevel7: "astdimsens.oa7",
        occupyLevel8: "astdimsens.oa8",
        occupyLevel9: "astdimsens.oa9",
        occupyLevel10: "astdimsens.oa10",
    },
    // Solar charge controller of MPPT drivers (am58962). Built from the MPPTData
    // SubDevice, so it exists only on drivers that carry one, and is independent of the
    // operating mode. Display names and units come from the fea file itself
    // (converters/mppt.py supplies them), so this map is only about property identity.
    solarChargeController: {
        shortName: "mppt",

        // battery selectors and the one generic current
        batteryType: "mppt.battype",
        systemVoltage: "mppt.sysv",
        maxChargingCurrent: "mppt.maxchgcur",

        lithium12OverDischargeProtection: "mppt.dchgv",
        lithium12OverDischargeRecovery: "mppt.dchgvr",
        lithium12FullChargeCutoff: "mppt.chgv",
        lithium12FullChargeRecovery: "mppt.chgvr",

        leadAcid12OverDischargeProtection: "mppt.vrla12uvp",
        leadAcid12OverDischargeRecovery: "mppt.vrla12uvpr",
        leadAcid12BoostCharge: "mppt.boostv",
        leadAcid12FloatCharge: "mppt.floatv",

        lithium24OverDischargeProtection: "mppt.lfp24uvp",
        lithium24OverDischargeRecovery: "mppt.lfp24uvpr",
        lithium24FullChargeCutoff: "mppt.lfp24chgv",
        lithium24FullChargeRecovery: "mppt.lfp24chgvr",

        leadAcid24OverDischargeProtection: "mppt.vrla24uvp",
        leadAcid24OverDischargeRecovery: "mppt.vrla24uvpr",
        leadAcid24BoostCharge: "mppt.vrla24boost",
        leadAcid24FloatCharge: "mppt.vrla24float",

        // PV input and light control
        sleepMode: "mppt.sleep",
        lightControlVoltage: "mppt.lcv",
        lightControlDelay: "mppt.lcdly",

        // selects the Battery vs LED temperature branch
        temperatureProtectionMode: "mppt.tpmode",

        // battery temperature protection, T1..T8
        chargingStopHigh: "mppt.t1",
        chargingStopLow: "mppt.t2",
        dischargingStopHigh: "mppt.t3",
        dischargingStopLow: "mppt.t4",
        chargingLimitHigh: "mppt.t5",
        chargingLimitLow: "mppt.t6",
        dischargingLimitHigh: "mppt.t7",
        dischargingLimitLow: "mppt.t8",

        // current limits
        chargeLimitCurrent1: "mppt.chgcurl1",
        chargeLimitCurrent2: "mppt.chgcurl2",
        dischargeLimitCurrent1: "mppt.dchgcurl1",
        dischargeLimitCurrent2: "mppt.dchgcurl2",
        deratingDischargeCurrentLimit: "mppt.dchgcurpct",

        // LED temperature
        ledTemperatureRecovery: "mppt.rcvtemp",
        ledTemperatureProtection: "mppt.prottemp",

        // output and derating
        intelligentOutputAdjustment: "mppt.smartlvl",
        deratingStartVoltage: "mppt.dstartv",
        deratingEndVoltage: "mppt.dendv",
        deratingEndCurrent: "mppt.dendcur",
        lightingMode: "mppt.lmode",

        // time base. Lighting Mode decides whether sunrise/sunset apply; Enable Daylight
        // Saving Time swaps the 30-region list for the plain UTC offset picker.
        sunriseTime: "mppt.sunrise",
        sunsetTime: "mppt.sunset",
        daylightSavingTime: "mppt.dst",
        regionTimeZone: "mppt.region",
        timeZone: "mppt.tz",

        // advance
        batteryLeadResistance: "mppt.blres",
    }
};

const ASTRO_DIM = features.astroDim;
const CONFIGURATION_LOCK = features.configurationLock;
const CONSTANT_LUMEN_OUTPUT = features.constantLumenOutput;
const DALI_DEXAL_SETTINGS = features.daliDexalSettings;
const DALI_DT8_TW_SETTINGS = features.daliDT8TWSettings;
const DEXAL_POWER_SUPPLY_UNIT = features.dexalPowerSupplyUnit;
const DIMMING_MODES = features.dimmingModes;
const DIM_TO_DARK = features.dimToDark;
const DIM_TO_WARM = features.dimToWarm;
const DRIVER_GUARD = features.driverGuard;
const EMERGENCY_MODE = features.emergencyMode;
const END_OF_LIFE = features.endOfLife;
const LAMP_OPERATING_TIME = features.lampOperatingTime;
const LED_MODULE = features.ledModule;
const LUMINAIRE_INFO = features.luminaireInfo;
const MAINS_DIM = features.mainsDIM;
const MULTIPLE_OUTPUT_CURRENT = features.multipleOutputCurrent;
const OPERATING_CURRENT = features.operatingCurrent;
const PRESENCE_DETECTION = features.presenceDetection;
const SOFT_SWITCH_OFF = features.softSwitchOff;
const STEP_DIM = features.stepDim;
const TOUCH_DIM_AND_SENSOR = features.touchDIMAndSensor;
const CORRIDOR = features.corridor;
const THERMAL_PROTECTION = features.thermalProtection;
const TUNING_FACTOR = features.tuningFactor;
const ZERO_TO_TEN = features.zeroToTen;
const DALI_ADDRESSING = features.DaliAddressing;
const RGBW = features.rgbw;
const CHANNEL_CONTROL = features.channelControl;
const PERMANENT_SHUTDOWN = features.permanentShutdown;
const DIMMING = features.dimming;
const ASTRO_DIM8 = features.ast8;
const STEP_DIM8 = features.sd8;
const PRESENCE_DETECTION8 = features.pd8;
const POWER_ON_DELAY = features.powerOnDelay;
const DIAGNOSTICS = features.diagnostics;
const REPEATER = features.repeater;
const PWM_DIM_MODE = features.pwmDimMode;
const ASTRO_DIM_TW = features.astroDimTW;
const ASTRO_DIM_5 = features.astroDim5;
const ASTRO_DIM_10 = features.astroDim10;
const ADJUSTABLE_DIM = features.adjustableDim;
const PWM_DIM = features.pwmDim;
const DIGITAL_DIM = features.digitalDim;
const DIM_SETTINGS = features.dimSettings;
const DIP_SETTINGS = features.dipswitchcurrentsettings;
const LIGHT_SENSOR = features.lightSensor;
const PULL_UP_CURRENT = features.pullUpCurrent;
const ANTI_FLICKER = features.antiFlicker;
const MLS_MULTI_LUM = features.multiLumSettings;
const SENSOR_MODE = features.sensorMode;
const ASTRO_DIM_SENSOR = features.astroDimSensor;
const SOFT_START = features.softStart;
const SOLAR_CHARGE_CONTROLLER = features.solarChargeController;

export {
    ASTRO_DIM,
    CONFIGURATION_LOCK,
    CONSTANT_LUMEN_OUTPUT,
    DALI_DEXAL_SETTINGS,
    DALI_DT8_TW_SETTINGS,
    DEXAL_POWER_SUPPLY_UNIT,
    DIMMING_MODES,
    DALI_ADDRESSING,
    DIM_TO_DARK,
    DIM_TO_WARM,
    DRIVER_GUARD,
    EMERGENCY_MODE,
    END_OF_LIFE,
    LAMP_OPERATING_TIME,
    LED_MODULE,
    LUMINAIRE_INFO,
    MAINS_DIM,
    MULTIPLE_OUTPUT_CURRENT,
    OPERATING_CURRENT,
    PRESENCE_DETECTION,
    SOFT_SWITCH_OFF,
    STEP_DIM,
    THERMAL_PROTECTION,
    TOUCH_DIM_AND_SENSOR,
    CORRIDOR,
    TUNING_FACTOR,
    ZERO_TO_TEN,
    RGBW,
    CHANNEL_CONTROL,
    PERMANENT_SHUTDOWN,
    DIMMING,
    ASTRO_DIM8,
    STEP_DIM8,
    PRESENCE_DETECTION8,
    POWER_ON_DELAY,
    DIAGNOSTICS,
    REPEATER,
    PWM_DIM_MODE,
    ASTRO_DIM_TW,
    ASTRO_DIM_5,
    ASTRO_DIM_10,
    ADJUSTABLE_DIM,
    PWM_DIM,
    DIGITAL_DIM,
    DIM_SETTINGS,
    DIP_SETTINGS,
    LIGHT_SENSOR,
    PULL_UP_CURRENT,
    ANTI_FLICKER,
    MLS_MULTI_LUM,
    SENSOR_MODE,
    ASTRO_DIM_SENSOR,
    SOFT_START,
    SOLAR_CHARGE_CONTROLLER
};
